{
  "contactEmail": "Billing contact email",
  "contactEmailLabel": "Primary Email address",
  "secondaryContactEmailLabel": "Additional (cc:) Email Addresses",
  "contactEmailDescription": "The email address that invoices and overage notifications are sent to.",
  "address": "Billing address",
  "addressDescription": "The billing address that will appear on your invoices.",
  "invoiceExtras": "Billing invoice extras",
  "invoiceExtrasLabel": "Invoice extras",
  "invoiceExtrasDescription": "Append specific contact or tax info to your invoices, like your full business name, VAT identification number or address of record here.",
  "unableToSave": "Unable to save billing settings at the moment, please try again later.",
  "settingsSaved": "Billing settings saved",
  "failedPayment": "{{ count }} Payment totaling {{ amount }} is due",
  "failedPayment_plural": "{{ count }} Payments totaling {{ amount }} are due",
  "downgradeInfo": "If we don’t receive the outstanding payment, your account will be moved to our <a href='https://$t(common:defaultHost)/pricing' target='_blank'>free Community plan</a> (live tail only with no log/data retention). If you have any questions, ",
  "contactSupport": "contact support"
}
